import $ from 'jquery';
// import { animateCSS } from '../../util/animate-css';
// import mpro from './mpro.init';

/**
 * @param {JQuery} $elem
 */
const getHandlerNamespace = ($elem) => {
	return `widget-change-handler-${$elem.attr('id')}`;
};

/**
 * @param {BindChangeOptions} opt
 */
mpro.formWidgetsHandleBindChange = function(opt) {

	/** @type {JQuery} */
	// @ts-ignore
	const $trigger = $(opt.trigger);
	const isCompound = opt.isCompound || false;
	const $widgets = opt.widgetsSelector ? $(opt.widgetsSelector) : $trigger;
	const { rowSelector } = opt;
	const handlerNamespace = getHandlerNamespace($trigger);
	const callback = opt.callback || null;
	const controlCallback = opt.controlCallback || null;
	const selAllWidgets = opt.allWidgetSelectors;
	const selAllSubWidgets = opt.subAllWidgetSelectors;
	const { mapValuesToWidgetSelectors } = opt;
	const actions = opt.actions || [];
	// const subMapValuesToWidgetSelectors = opt.subMapValuesToWidgetSelectors;
	const firstData = $widgets.first().data();
	const affectParentRows = opt.affectParentRows || false;

	// No trigger on init
	if (opt.triggerOnInit === false) {
		firstData.skipTriggerChangeWidget = true;
	}
	// Trigger on init
	else {
		firstData.skipTriggerChangeWidget = false;
	}

	/**
	 * @param {string} widgetSetState
	 */
	const getSelectedWidgets = (widgetSetState) => {
		const hasMapWidgets = (mapValuesToWidgetSelectors && !$.isEmptyObject(mapValuesToWidgetSelectors)) ? true : false;
		const selWidgetsOn = hasMapWidgets ? (mapValuesToWidgetSelectors[widgetSetState] || null) : null;
		let selWidgetsOff;

		// Select only widgets mapped to the state value as 'off' widgets
		if (hasMapWidgets) {
			// Convert selectors to array of widget ids
			const arrWidgetsOff = [];
			const selWidgetsOnArr = selWidgetsOn && selWidgetsOn.replaceAll(/\s+/gi, '').split(',') || [];

			// Intersect off values with on values so it doesn't conflict
			for (const widgetValue in mapValuesToWidgetSelectors) {
				if (Object.hasOwn(mapValuesToWidgetSelectors, widgetValue)) {
					const widgetSelectors = mapValuesToWidgetSelectors[widgetValue];

					if ((widgetValue !== widgetSetState) && widgetSelectors) {
						const widgetSelectorsArr = widgetSelectors.replaceAll(/\s+/gi, '').split(',');
						const intersectSelArr = [];

						for (const selector of widgetSelectorsArr) {
							if (selWidgetsOnArr.includes(selector) === false) {
								intersectSelArr.push(selector);
							}
						}

						if (intersectSelArr.length > 0) {
							arrWidgetsOff.push(intersectSelArr.join(','));
						}
					}
				}
			}
			selWidgetsOff = arrWidgetsOff.join(',');
		}
		// All widgets are 'off' widgets
		else {
			selWidgetsOff = selAllWidgets;
		}

		return { selWidgetsOn, selWidgetsOff };
	};

	/**
	 * @type {(this: HTMLElement, e: JQuery.TriggeredEvent, widgetSetState: string, forceAllWidgets?: boolean) => void}
	 */
	const widgetOffHandler = function(e, widgetSetState, forceAllWidgets) {
		const $self = $(this);
		// All widgets are forced to 'off' state
		const selWidgetsOff = forceAllWidgets === true ? selAllWidgets : getSelectedWidgets(widgetSetState).selWidgetsOff;

		// Have sub widgets
		if (selAllSubWidgets) {

			/**
			 * Trigger sub widgets 'off' state
			 * @type {(this: HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement|HTMLElement) => void}
			 */
			const subOffHandler = function() {
				const $subMainWidget = $(this);
				const $widgetTargetContainer = $subMainWidget.closest(rowSelector);

				// Checkbox/Radio
				if ($subMainWidget.is('input[type=checkbox],input[type=radio]')) {
					/* Make sure we don't do this multiple times and lose the original prevSelectedWidget value */
					// @ts-ignore
					if (this && !this.jquery && (this.checked === true) && !this.disabled) {
						// @ts-ignore
						$widgetTargetContainer.data('prevSelectedWidget', { jqWidget: $subMainWidget, checked: this.checked });
						$subMainWidget.prop('checked', false).triggerNative('change');
					}
				}
				// Rest of form elements
				else if ($subMainWidget.is('input,textarea,select')) {
					/* Make sure we don't do this multiple times and lose the original prevSelectedWidget value */
					// @ts-ignore
					if (!this.disabled) {
						$widgetTargetContainer.data('prevSelectedWidget', { jqWidget: $subMainWidget, val: $subMainWidget.val() });
						$subMainWidget.val('').triggerNative('change');
					}
				}
				// Compound - recurse
				else {
					$subMainWidget.find('input,select,textarea').each(subOffHandler);
				}
			};

			// Run the sub 'off' handler for all sub-widgets
			$(selAllSubWidgets).each(subOffHandler);
		}

		const $allOffWidgets = $(selWidgetsOff);
		const numColWidgets = $allOffWidgets.length;

		// Apply the 'off' handler for each widget
		$allOffWidgets.each(function(widgetColId) {
			// Select required components
			const $target = $(this);
			// Make sure input[type="hidden"] is excluded from row grabbing (it does not usually have a row)
			const $targetRow = $target.is('input[type="hidden"]') ? $() : $target.closest(rowSelector);
			const $targetFormElems = $target.is('input,select,textarea')
				? $target
				: $target.find('input,select,textarea').not('.ignore-bind-change');

			// Action: DISABLE
			if (actions.includes('disable')) {

				// Flag the container that its widgets are disabled
				$targetRow.data('disableOnChange', true);

				// Visually disabled
				$targetRow.children().add($target).addClass('disabled');

				// Visually disable all parent rows
				const $targetSameRowParents = affectParentRows ? $targetRow.parents(rowSelector) : $();
				if ($targetSameRowParents.length > 0) {
					$targetSameRowParents.children().addClass('disabled');
				}

				// Prepare form elements props
				// @ts-ignore
				$targetFormElems.each(function() {
					const $elem = $(this);
					// Save the required state
					// @ts-ignore
					$elem.data('prop_required', this.required);
					// @ts-ignore
					this.required = false;
					// @ts-ignore
					this.disabled = true;

					// Trigger custom disable event on the form element
					$elem.trigger('disable.bind-change-action', {
						disable: true, initor: $self, target: $target, targetElements: $targetFormElems, container: $targetRow,
					});
				});

				// Trigger a custom disable event on the row
				$targetRow.trigger('disable.bind-change-action-container', {
					disable: true, initor: $self, target: $target, targetElements: $targetFormElems, container: $targetRow,
				});
			}

			// Action: HIDE
			if (actions.includes('hide')) {

				const $targetSameRowParents = affectParentRows ? $targetRow.parents(rowSelector) : $();
				let $hideContainers = $targetRow;

				if ($targetSameRowParents.length > 0) {
					$hideContainers = $hideContainers.add($targetSameRowParents);
				}

				// Flag the container that its widgets are hidden
				$targetRow.data('hideOnChange', true);

				// Hide the containers
				$hideContainers.finish().hide();
			}

			// Trigger the callback
			callback && callback('off', $self, $target, $targetRow, $targetFormElems, widgetColId, numColWidgets, e);
		});
	};

	/**
	 * @type {(this: HTMLElement, e: JQuery.TriggeredEvent, widgetSetState: string, forceAllWidgets?: boolean) => void}
	 */
	const widgetOnHandler = function(e, widgetSetState, forceAllWidgets) {
		const $self = $(this);
		// All widgets are forced to 'on' state
		const selWidgetsOn = forceAllWidgets === true ? selAllWidgets : getSelectedWidgets(widgetSetState).selWidgetsOn;

		const $allOnWidgets = $(selWidgetsOn);
		const numColWidgets = $allOnWidgets.length;

		// Apply the 'on' handler for each widget
		$allOnWidgets.each(function(widgetColId) {
			// Select required components
			const $target = $(this);
			const targetData = $target.data();
			// Make sure input[type="hidden"] is excluded from row grabbing (it does not usually have a row)
			const $targetRow = $target.is('input[type="hidden"]') ? $() : $target.closest(rowSelector);
			/** @type {{ jqWidget: JQuery; val?: any; checked?: boolean; }} */
			const prevSelectedWidget = $targetRow.data('prevSelectedWidget');
			const $targetFormElems = $target.is('input,select,textarea')
				? $target
				: $target.find('input,select,textarea').not('.ignore-bind-change');

			// Action: DISABLE
			if (actions.includes('disable')) {

				// Flag the container that its widgets are no longer disabled
				$targetRow.data('disableOnChange', false);

				// Remove visually disabled state
				$targetRow.children().add($target).removeClass('disabled');

				// Remove visually disabled from all parent rows
				const $targetSameRowParents = affectParentRows ? $targetRow.parents(rowSelector) : $();
				if ($targetSameRowParents.length > 0) {
					$targetSameRowParents.children().removeClass('disabled');
				}

				// Restore form elements props
				// @ts-ignore
				$targetFormElems.each(function() {
					const $elem = $(this);
					if ($elem.data('prop_required') === true) {
						// @ts-ignore
						this.required = true;
					}
					// @ts-ignore
					this.disabled = false;

					// Trigger a custom disable event on the form element
					$elem.trigger('disable.bind-change-action', {
						disable: false, initor: $self, target: $target, targetElements: $targetFormElems, container: $targetRow,
					});

					/* Wrong implementation logic */
					/* if (jqThis.is('select')) {
						jqThis.find('option').prop('disabled', false);
						if (!jqThis.is('[multiple]')) {
							var jqSelOption = jqThis.find('option[selected]');
							if (!jqSelOption.length) {
								jqSelOption = jqThis.find('option').first();
							}
							setTimeout(function(){
								jqSelOption.attr('selected', 'selected');
							}, 100);
						}
					} */
				});

				// Trigger a custom disable event on the row
				$targetRow.trigger('disable.bind-change-action-container', {
					disable: false, initor: $self, target: $target, targetElements: $targetFormElems, container: $targetRow,
				});
			}

			// Action: HIDE
			if (actions.includes('hide')) {

				const $targetSameRowParents = affectParentRows ? $targetRow.parents(rowSelector) : $();
				let $hideContainers = $targetRow;

				if ($targetSameRowParents.length > 0) {
					$hideContainers = $hideContainers.add($targetSameRowParents);
				}

				// Flag the container that its widgets are not hidden anymore
				$targetRow.data('hideOnChange', false);

				// Show the containers
				$hideContainers.finish().show();
			}

			// Initial disabled/required states (from backend)
			if (targetData.protoDisabled === true || targetData.protoRequired === true) {
				// Restore elements states
				// @ts-ignore
				$targetFormElems.each(function() {
					// @ts-ignore
					this.disabled = targetData.protoDisabled;
					// @ts-ignore
					this.required = targetData.protoRequired;
				});
			}

			// Restore the prevSelectedWidget
			if (prevSelectedWidget && prevSelectedWidget.jqWidget) {
				// Defer execution to next stack
				setTimeout(() => {
					if ('checked' in prevSelectedWidget) {
						prevSelectedWidget.jqWidget.prop('checked', prevSelectedWidget.checked);
					}
					else if ('val' in prevSelectedWidget) {
						prevSelectedWidget.jqWidget.val(prevSelectedWidget.val);
					}
					prevSelectedWidget.jqWidget.triggerNative('change');
					$targetRow.data('prevSelectedWidget', null);
				});
			}

			// Execute the callback
			callback && callback('on', $self, $target, $targetRow, $targetFormElems, widgetColId, numColWidgets, e);
		});

		// Have sub widgets - execute last
		if (selAllSubWidgets) {

			/**
			 * Trigger sub widgets 'on/off' state
			 * @type {(this: HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement|HTMLElement, namespace?: string) => void}
			 */
			// const subOnOffHandler = function (namespace) {
			// 	const $subMainWidget = $(this);
			// 	// This is the first level, get actual event namespace
			// 	if (!namespace) {
			// 		namespace = getHandlerNamespace($subMainWidget);
			// 	}

			// 	// Form widgets
			// 	if ($subMainWidget.is('input,textarea,select')) {
			// 		/* Make sure we don't do this multiple times and lose the original prevSelectedWidget value */
			// 		// @ts-ignore
			// 		if (!this.disabled) {
			// 			// debugger;
			// 			$subMainWidget.triggerHandler('change.' + namespace);
			// 			// debugger;
			// 		}
			// 	}
			// 	// Compound - recurse
			// 	else {
			// 		$subMainWidget.find('input,select,textarea').each(function () {
			// 			// Pass namespace from first level
			// 			subOnOffHandler.call(this, namespace);
			// 		});
			// 	}
			// };

			// Run the sub 'on/off' handler for all sub-widgets
			// TODO
			// $(selAllSubWidgets).each(function () {
			// 	subOnOffHandler.call(this);
			// });
		}
	};

	/**
	 * @type {(this: HTMLElement|null, e?: JQuery.TriggeredEvent) => void}
	 */
	const widgetChangeHandler = function(e) {

		let $self = $(this);
		let selfWidget = this;
		let widgetSetState;

		// Checkbox/Radio
		if (!isCompound && $self.is('input[type=checkbox],input[type=radio]')) {
			// The state is the checked flag
			// @ts-ignore
			widgetSetState = selfWidget && !selfWidget.jquery && (selfWidget.checked).toString() || '';
		}
		// Compound widget
		else {
			// Checkbox
			if ($self.is('input[type=checkbox],input[type=radio]')) {
				// State is the input val
				// @ts-ignore
				if (selfWidget.checked) {
					widgetSetState = $self.val();
				}
				// State is nothing (same as the self refs)
				else {
					selfWidget = null;
					$self = $();
					widgetSetState = '';
				}
			}
			// Other form element types
			else {
				widgetSetState = $self.val() || '';
			}
		}

		let controlCalled = false;

		// Get state widgets
		const currentStateWidgets = getSelectedWidgets(widgetSetState);

		// console.log('selAllWidgets', selAllWidgets);
		// console.log('widgetSetState', widgetSetState);
		// console.log('selWidgetsOn', currentStateWidgets.selWidgetsOn);
		// console.log('selWidgetsOff', currentStateWidgets.selWidgetsOff);

		// We have a control callback defined
		if (selAllWidgets && controlCallback) {
			const $onTargets = $(currentStateWidgets.selWidgetsOn);
			const $offTargets = $(currentStateWidgets.selWidgetsOff);
			const $allTargets = $onTargets.add($offTargets);

			// Call the control callback for fine-grained handling
			controlCallback.call(
				selfWidget,
				() => {
					controlCalled = true; return widgetOnHandler.call(selfWidget, e, widgetSetState, true);
				},
				() => {
					controlCalled = true; return widgetOffHandler.call(selfWidget, e, widgetSetState, true);
				},
				$self,
				$allTargets,
				$onTargets,
				$offTargets,
			);
		}

		// Control was not called, we must handle this
		if (controlCalled === false) {
			if (selAllWidgets) {
				const { selWidgetsOn } = currentStateWidgets;
				const { selWidgetsOff } = currentStateWidgets;

				if (selWidgetsOff) {
					widgetOffHandler.call(selfWidget, e, widgetSetState);
				}
				if (selWidgetsOn) {
					widgetOnHandler.call(selfWidget, e, widgetSetState);
				}
			}
		}
	};

	// Bind the handler directly on the form
	$widgets.on(`change.${handlerNamespace}`, widgetChangeHandler);
	$widgets.on(`off-state.${handlerNamespace}`, function(e) {
		widgetOffHandler.call(this, e, 'false');
	});

	// Do not set initial state
	if (!firstData || !firstData.skipTriggerChangeWidget) {
		if (isCompound) {
			const jqCheckedWidget = $widgets.filter(':checked');
			if (jqCheckedWidget.length > 0) {
				jqCheckedWidget.triggerHandler(`change.${handlerNamespace}`);
			}
			else {
				widgetChangeHandler.call(null);
			}
		}
		else {
			$widgets.triggerHandler(`change.${handlerNamespace}`);
		}
	}
	// Reset the initial state
	else if (firstData) {
		firstData.skipTriggerChangeWidget = false;
	}
};

mpro.formWidgetsHandleBindCopyValue = function(opt) {
	const jqFormChangeWidgets = $(opt.form_id);
	const rowSelector = opt.row_class;
	const widgetIsCompound = opt.is_compound || false;
	const callback = opt.callback || null;
	const handlerNamespace = opt.handler_namespace;
	const remoteUrl = opt.remote_url || null;
	const jqAllWidgetSelectors = opt.all_widget_selectors;
	const throttleDelay = 200;
	let prevRemote;
	let throttleTimer;
	const noTriggerSearchKeys = {
		'9': 'tab',
		'13': 'enter',
		'16': 'shift',
		'17': 'ctrl',
		'18': 'alt',
		'27': 'esc',
		'33': 'page up',
		'34': 'page down',
		'35': 'end',
		'36': 'home',
		'37': 'left arrow',
		'38': 'up arrow',
		'39': 'right arrow',
		'40': 'down arrow',
		'91': 'left meta',
		'92': 'right meta',
		'93': 'select',
		'112': 'f1',
		'113': 'f2',
		'114': 'f3',
		'115': 'f4',
		'116': 'f5',
		'117': 'f6',
		'118': 'f7',
		'119': 'f8',
		'120': 'f9',
		'121': 'f10',
		'122': 'f11',
		'123': 'f12',
		'144': 'num lock',
		'145': 'scroll lock',
	};
	const callRemote = function(url, term, callback) {
		if (prevRemote) {
			prevRemote.abort();
		}
		prevRemote = $.ajax({
			url,
			data: { q: term },
			method: 'get',
			dataType: 'json',
			success: callback,
		})
			.fail((jqXhr, textStatus, errorThrown) => {
				if (textStatus !== 'abort') {
					console.warn('Widget copy_value remote', `Ajax failed: [url: ${url}]`, jqXhr, textStatus, errorThrown);
				}
			});
		return prevRemote;
	};
	const callThrottledRemote = function(url, term, callback) {
		clearTimeout(throttleTimer);
		throttleTimer = setTimeout(callRemote, throttleDelay, url, term, callback);
	};

	/**
	 * @this {HTMLInputElement & JQuery}
	 * @param {JQuery.TriggeredEvent=} e
	 */
	const widgetChangeHandler = function(e) {
		const key = e ? (window.event ? e.keyCode : e.which) : null;
		if (e && e.type === 'keyup' && key && noTriggerSearchKeys[key]) {
			return;
		}
		let jqWidgetMain = $(this);
		let that = this;
		let widgetSetState;
		if (!widgetIsCompound && jqWidgetMain.is('input[type=checkbox],input[type=radio]')) {
			widgetSetState = that && !that.jquery && (that.checked).toString() || '';
		}
		else {
			if (jqWidgetMain.is('[type=checkbox]')) {
				if (that.checked) {
					widgetSetState = jqWidgetMain.val();
				}
				else {
					// @ts-ignore
					that = jqWidgetMain = $();
					widgetSetState = '';
				}
			}
			else {
				widgetSetState = jqWidgetMain.val() || '';
			}
		}
		if (remoteUrl) {
			callThrottledRemote(remoteUrl, widgetSetState, (data, _textStatus, _jqXhr) => {
				if (data) {
					widgetSetState = typeof data.content !== 'undefined' ? data.content : data;
				}
				else {
					widgetSetState = '';
				}
				// --- PROCESS_EVENT ---
				const jqAllWidgets = $(jqAllWidgetSelectors);
				const numColWidgets = jqAllWidgets.length;
				jqAllWidgets.each(function(i) {
					const widgetColId = i;
					const jqWidgetTarget = $(this);
					const jqWidgetTargetContainer = jqWidgetTarget.closest(rowSelector);
					let jqWidgetTargetFormElems = jqWidgetTarget;
					if (!jqWidgetTarget.is('input,select,textarea')) {
						jqWidgetTargetFormElems = jqWidgetTarget.find('input,select,textarea');
					}
					// Filter disabled fields
					jqWidgetTargetFormElems = jqWidgetTargetFormElems.filter(':not(:disabled)');
					jqWidgetTargetFormElems.val(widgetSetState);
					callback && callback('copy_value', jqWidgetMain, jqWidgetTarget, jqWidgetTargetContainer, jqWidgetTargetFormElems, widgetColId, numColWidgets, e);
				});
				// --- END: PROCESS_EVENT ---
			});
		}
		else {
			// --- PROCESS_EVENT ---
			const jqAllWidgets = $(jqAllWidgetSelectors);
			const numColWidgets = jqAllWidgets.length;
			jqAllWidgets.each(function(i) {
				const widgetColId = i;
				const jqWidgetTarget = $(this);
				const jqWidgetTargetContainer = jqWidgetTarget.closest(rowSelector);
				let jqWidgetTargetFormElems = jqWidgetTarget;
				if (!jqWidgetTarget.is('input,select,textarea')) {
					jqWidgetTargetFormElems = jqWidgetTarget.find('input,select,textarea');
				}
				// Filter disabled fields
				jqWidgetTargetFormElems = jqWidgetTargetFormElems.filter(':not(:disabled)');
				jqWidgetTargetFormElems.val(widgetSetState);
				callback && callback('copy_value', jqWidgetMain, jqWidgetTarget, jqWidgetTargetContainer, jqWidgetTargetFormElems, widgetColId, numColWidgets, e);
			});
			// --- END: PROCESS_EVENT ---
		}
	};
	let pasteTimer;
	// jqFormChangeWidgets.on('keydown.' + handlerNamespace, widgetChangeHandler);
	jqFormChangeWidgets.on(`change.${handlerNamespace}`, widgetChangeHandler);
	jqFormChangeWidgets.on(`keyup.${handlerNamespace}`, widgetChangeHandler);
	jqFormChangeWidgets.on(`paste.${handlerNamespace}`, (_e) => {
		clearTimeout(pasteTimer);
		pasteTimer = setTimeout(() => {
			// @ts-ignore
			widgetChangeHandler.call($());
		}, 50);
	});
	if (widgetIsCompound) {
		const jqCheckedWidget = jqFormChangeWidgets.filter(':checked');
		if (jqCheckedWidget.length > 0) {
			jqCheckedWidget.triggerHandler(`change.${handlerNamespace}`);
		}
		else {
			// @ts-ignore
			widgetChangeHandler.call($());
		}
	}
	else {
		jqFormChangeWidgets.triggerHandler(`change.${handlerNamespace}`);
	}
};

/**
 * The submit button should change classes after a widgets has been changes
 *
 * @param {JQuery} $container
 */
mpro.formWidgetsHandleSubmitButton = ($container) => {

	$container.find('form').each((_, element) => {

		const $form = $(element);
		const $button = $form.find('button[type="submit"][data-on-change-class],input[type="submit"][data-on-change-class]');

		if ($button.length > 0) {
			// const classNamesArr = $button[0].className.split(/\s+/).filter(v => v.startsWith('btn-') && !v.startsWith('btn-outline'));
			// const classNames = classNamesArr.join(' ');
			// const outlineClassNames = classNamesArr.map(v => v.replace('btn-', 'btn-outline-')).join(' ');
			const classNamesArr = $button[0].className.split(/\s+/u).filter(v => v.startsWith('btn-'));
			const outlineClassNames = classNamesArr.join(' ');
			const classNames = $button.data('onChangeClass');
			// $button.removeClass(classNames).addClass(outlineClassNames);

			$form.find('input,select,textarea').one('change.submitButtonOutline', (e) => {
				$button.removeClass(outlineClassNames).addClass(classNames);
			});
		}
	});
};

export default mpro;
